import React, {Component} from 'react';
import {connect} from 'react-redux';
import Properties from '../../shared/Properties';
import {fetchRetiredProperties} from '../../../actions';

class Container extends Component {
    render() {
        return <Properties {...this.props} includeHeader={false}/>;
    }
}

const mapStateToProps = (state, ownProps) => {
    const properties = state.landlord.properties.retired;
    return {
        landlord: state.me.application.id,
        properties: [...properties.data],
        meta: properties.meta,
        loading: properties.isFetching,
    };
};

export default connect(mapStateToProps, {fetchProperties: fetchRetiredProperties})(Container);



// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/property/RetiredProperties.js